<template>
  <div class="box vh-140">
    <div class="box-header">
      <i class="fa fa-th-large"></i>
      <h3 class="box-title">试卷列表</h3>
    </div>
    <div class="box-body">
      <el-row class="margin-bottom-10" gutter="20">
        <el-col :span="18">
          <el-button type="primary" size="small" @click="toAddPapers()" plain><i class="fa fa-plus"></i> 添加试卷</el-button>
        </el-col>
        <el-col :span="6">
          <el-input size="small" type="text" placeholder="请试卷名称" v-model="searchFm.title">
            <el-button slot="append" size="small" @click="doSearch()" type="primary"><i class="fa fa-search"></i> 搜索</el-button>
          </el-input>
        </el-col>
      </el-row>

      <el-table class="list-table" :data="paperList" border :stripe="true" style="width: 100%"
                :header-cell-style="{ background: '#eef1f6', color: '#606266' }">
        <template slot="empty">
          <div class="no-data">暂无数据！</div>
        </template>
        <el-table-column label="序号" width="50">

          <template slot-scope="scope">
            <span>{{ page.pageSize * (page.pageNo - 1) + scope.$index + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column label="标题" prop="title"></el-table-column>
        <el-table-column label="副标题" prop="subtitle"></el-table-column>
        <el-table-column prop="type" label="类型" width="100"></el-table-column>
        <el-table-column prop="category" label="分类" width="100"></el-table-column>
        <el-table-column prop="price" label="价格" width="50"></el-table-column>
        <el-table-column prop="visit" label="访问量" width="100"></el-table-column>
        <el-table-column fixed="right" label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click.prevent="toQuestions(scope.row)" size="small"><i class="fa fa-eye"></i> 查看</el-button>
            <el-button type="text" @click.prevent="toPaperResult(scope.row.id)" size="small"><i class="fa fa-cubes"></i> 结果
            </el-button>
            <el-button type="text" @click.prevent="toEditPapers(scope.row.id)" size="small"><i class="fa fa-edit"></i> 编辑
            </el-button>
            <el-button type="text" @click.prevent="deletePapers(scope.row.id)" size="small"><i class="fa fa-trash"></i> 删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <page-bar v-model="page" @change="fetchData"></page-bar>

      <!-- 试题列表-->
      <question-list :visible="questionDrawer" v-model="paper" @done="handleQuestion"></question-list>

      <!-- 试卷结果集-->
      <paper-result :visible="resultDrawer" :echoId="paperId" @done="handleResult"></paper-result>

      <!-- 试卷编辑、保存-->
      <paper-save :visible="paperDrawer" :echoId="paperId" @done="handlePaper"></paper-save>

    </div>
  </div>
</template>

<script>
import { fetchList, remove } from "@/api/manage/paper";
import PageBar from "@/components/PageBar.vue";
import QuestionList from "./QuestionList.vue";
import paperResult from "./PaperResult.vue";
import paperSave from "./PaperSave.vue";
import { handleConfirm } from "@/utils/confirm";
import { getResultTypeList } from "@/api/manage/mate";

export default {
  name: "ev-paper",
  components: {
    PageBar,
    QuestionList,
    paperResult,
    paperSave
  },
  created() {
    this.fetchData();
    this.getResultTypeList();
  },
  data: function() {
    return {
      resultDrawer: false,
      paperDrawer: false,
      searchFm: {},
      questionDrawer: false,
      page: {
        pageSize: 20,
        pageNo: 1
      },
      paperList: [],
      paperTypeList: [], // 统计结果类型
      paper: {},
      paperId: ""
    };
  },
  methods: {
    fetchData() {
      let { pageNo, pageSize } = this.page;
      let query = { pageNo, pageSize, param: { ...this.searchFm } };
      query.param.title = query.param.title ? `%${query.param.title}%` : null;
      fetchList(query).then(resp => {
        let data = resp.data.result;
        this.$set(this, "page", data);
        this.paperList = data.records;
      });
    },
    toAddPapers() {
      this.paperId = "";
      this.paper = {};
      this.paperDrawer = true;
    },
    toEditPapers(val) {
      this.paperId = val;
      this.paperDrawer = true;
    },
    deletePapers(val) {
      handleConfirm("此操作将永久删除, 是否继续?").then(() => {
        remove(val).then(resp => {
          this.$message.success(resp.data.message);
          this.fetchData();
        });
      });
    },
    toQuestions(val) {
      this.paper = val;
      this.questionDrawer = true;
    },
    getResultTypeList() {
      getResultTypeList().then(res => {
        this.paperTypeList = res.data.result;
      });
    },
    toPaperResult(id) { // 查看试卷结果
      this.paperId = id;
      this.resultDrawer = true;
    },
    handlePaper() {
      this.paperDrawer = false;
      this.paper = {};
      this.paperId = "";
      this.page.pageNo = 1;
      this.fetchData();
    },
    handleQuestion() {
      this.questionDrawer = false;
    },
    handleResult() {
      this.resultDrawer = false;
    },
    doSearch() {
      this.fetchData();
    }
  }
};
</script>
